import * as React from 'react';
import { COPY } from '../invite/copy';

interface State {
  failed: boolean;
}

// Inline styles on purpose: the page styles ship inside the lazy chunks, which are exactly what failed
// to load here, so no class from them is available. Importing invite.css would put it in the main bundle.
const wrap: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  gap: 10,
  padding: '120px 32px 0',
  fontFamily: "'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif",
  color: '#302b22',
};
const button: React.CSSProperties = {
  minHeight: 54,
  width: '100%',
  maxWidth: 220,
  marginTop: 8,
  border: 0,
  borderRadius: 12,
  background: '#ffb82f',
  color: '#302b22',
  boxShadow: '0 4px 0 #c98a00',
  font: "600 16px/1 'Inter', system-ui, sans-serif",
  cursor: 'pointer',
};

// Every page is a lazy chunk. If one cannot load (offline, flaky network, or a deploy replaced the
// hashed file while the tab was open) React would throw through Suspense and unmount the whole app to a
// blank page. This wraps the lazy routes and offers a reload instead.
export default class ChunkLoadBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  render() {
    if (!this.state.failed) {
      return this.props.children;
    }
    return (
      <div role="alert" style={wrap}>
        <h1 style={{ margin: 0, font: "700 22px/28px 'Literata', Georgia, serif" }}>{COPY.loadFailedTitle}</h1>
        <p style={{ margin: 0, color: '#736f66', font: "400 16px/22px 'Inter', system-ui, sans-serif" }}>
          {COPY.loadFailedBody}
        </p>
        <button type="button" style={button} onClick={() => window.location.reload()}>
          {COPY.reload}
        </button>
      </div>
    );
  }
}
